export function round2(n) { 
  return Math.round(n * 100) / 100;
}

export function parseSep(raw) {
  if (raw == null) return 0;
  const n = parseFloat(String(raw).replace(/[R\s,]/g, ''));
  return isNaN(n) ? 0 : n;
}

export function fmtR(n) {
  return 'R\u202f' + Number(n).toFixed(2);
}

const DOSAGE_UNITS = {
  cream:'g', ointment:'g/ml', sachet:'g/mg', syrup:'ml',
  powder:'g', drops:'ml', liquid:'ml', suspension:'g/ml',
  gel:'g/ml', injection:'ml', tablet:'tablets', pill:'pills',
  capsule:'capsules', 'effervescent tablet':'effervescent tablets'
};

export function dosageUnit(form) { 
  return DOSAGE_UNITS[(form||'').toLowerCase()] || ''; 
}

const ESC_MAP = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

export function esc(s) {
  return String(s ?? '').replace(/[&<>"']/g, c => ESC_MAP[c]);
}

export function escAttr(s) {
  return esc(s); // The new esc() already handles quotes
}

export function capitalise(s) {
  return s ? String(s).replace(/(?:^|\s)\S/g, c => c.toUpperCase()) : s;
}
